// extracted by mini-css-extract-plugin
export default {"departments":"fG-z","departmentHeading":"gG-z","departmentSection":"hG-z","departmentName":"iG-z","departmentLink":"jG-z","expandIcon":"kG-z"};